import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
}

export interface ChatPayload {
  message: string;
  history?: ChatMessage[];
}

export interface ChatResponse {
  reply: string;
  tool_used: string | null;
}

export async function sendChatMessage(data: ChatPayload) {
  return axios.post<{ data: ChatResponse; success: boolean; message: string; code: number }>(
    API_ENDPOINTS.AI_AGENT_CHAT,
    data
  );
}
